import './banner_page.css'

const BannerSection = ({banner, title, isCurrent}) => {

      return (
            <div className={isCurrent !== '' ? "banner_page reverse" : "banner_page"}>
                  <div className="main_banner__page">
                        <img src={banner} alt={title} />
                  </div>
            </div>
      )
}

export default BannerSection
